/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import React from 'react';

export default function ContextSkeleton(
  responseDataValue,
  itemArrayValue,
  setterData,
  customerId,
  priceController,
  competitorDDValue,
  tireController?
): any {
  console.log('responseDataValue chedcdjvbw', responseDataValue);
  console.log('priceController jhfvbvhbf', priceController);
  const queryParams = new URLSearchParams(window.location.search);
  const isExchangeQP: any = queryParams.get('isExchange');
  const contextObject: any = {
    storeNumber: sessionStorage.getItem('storeNumber'),
    customerId: parseInt(customerId),
    // Use backend-adjusted values so Agreement Details shows and quotes the effective rate and term after an override.
    agreementRate: parseFloat(responseDataValue.agreementPricing.agreementRate),
    agreementTerm:
      isExchangeQP == 1
        ? parseFloat(responseDataValue.agreementPricing.exchangeAgreementTerm)
        : parseInt(responseDataValue.agreementPricing.agreementTerm),
    sacTotal:
      isExchangeQP == 1
        ? parseFloat(responseDataValue.agreementPricing.exchangeCashPrice)
        : parseFloat(responseDataValue.agreementPricing.cashPrice),
    inventoryIds: itemArrayValue,
    agreementType: 'RTO',
    actualAgreementRate: parseFloat(
      responseDataValue.agreementPricing.agreementRate
    ),
    actualAgreementTerm:
      isExchangeQP == 1
        ? parseFloat(responseDataValue.agreementPricing.exchangeAgreementTerm)
        : parseInt(responseDataValue.agreementPricing.agreementTerm),
    tagTotal: parseFloat(responseDataValue.agreementPricing.tagTotal),
    sacPrice:
      isExchangeQP == 1
        ? parseFloat(responseDataValue.agreementPricing.exchangeCashPrice)
        : parseFloat(responseDataValue.agreementPricing.cashPrice),
    inventory: itemArrayValue,
    customer: [
      {
        customerId: parseInt(customerId),
        priority: 1,
      },
    ],
    AgreementTotal:
      isExchangeQP == 1
        ? responseDataValue.agreementPricing.exchangeAgreementTotal
        : responseDataValue.agreementPricing.agreementTotal,
    TireAgreementFlow: tireController,
    itemDescription:
      responseDataValue.itemPricing[0].packageName !== null
        ? responseDataValue.itemPricing[0].packageName
        : responseDataValue.itemPricing[0].inventoryName,
    competitorId: competitorDDValue == '0' ? null : competitorDDValue,
  };
  console.log('contextObject', contextObject);

  setterData(contextObject);
}
